var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e771d8999c5c1f52213087dfb4386eb4356ff6af"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blipp-frontend@blipp-ab"]={id:"e771d8999c5c1f52213087dfb4386eb4356ff6af"};
      